import IClipboardTool from '@/module/common/service/UtilsService/contract/IClipboardTool';

class ClipboardTool implements IClipboardTool {
  copy = (value: string): Promise<unknown> => navigator.clipboard.writeText(value);
}

export default ClipboardTool;
